<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="">
        <el-button type="success" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          v-permission="'coachCoopRefund'"
          type="danger"
          @click="openRefund"
          >合作保证金退款</el-button
        >
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
          {{ getNameByValue(coopType, row.type) }}
        </div>
      </template>
      <template #end_time="{ row }">
        <div @click="openTimeUpdate(row)">
          {{ row.end_time }}<i class="el-icon-edit time_edit"></i>
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="success" v-if="row.status == 1">可用</el-tag>
          <el-tag type="info" v-if="row.status == 2">不可用</el-tag>
          <el-tag type="info" v-if="row.status == 3">已退款</el-tag>
          <el-tag type="warning" v-if="row.status == 0">待支付</el-tag>
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button v-if="row.status == 1" type="primary" @click="openSet(row)"
            >设置</el-button
          >
          <el-button
            v-if="row.status == 1"
            type="danger"
            @click="updateStatus(row, 2)"
            >停用</el-button
          >
          <el-button
            v-if="row.status == 2"
            type="success"
            @click="updateStatus(row, 1)"
            >开通使用</el-button
          >
        </div>
      </template>
    </auto-table>

    <h2>待办任务</h2>
    <auto-table
      :DataList="unPayDataList"
      :option="unPayOption"
      :total="unPayTotal"
      @changePage="getUnPayList"
    >
      <template #type>
        <div>保证金</div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="success" v-if="row.status == 1">已支付</el-tag>
          <el-tag type="info" v-if="row.status == 2">取消</el-tag>
          <el-tag type="warning" v-if="row.status == 0">待支付</el-tag>
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button
            type="danger"
            v-if="row.status == 0"
            @click="cancelPartner(row)"
            >取消合作</el-button
          >
        </div>
      </template>
    </auto-table>

    <el-dialog
      :visible.sync="updateShow"
      width="50%"
      title="合作门店设置"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="合作门店" required>
          {{ curItem.mechanism ? curItem.mechanism.mechanism_name : "" }}
        </el-form-item>
        <el-form-item label="合作时间" required>
          <el-date-picker
            v-model="curItem.start_time"
            value-format="yyyy-MM-dd 00:00:00"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-date-picker
            v-model="curItem.end_time"
            value-format="yyyy-MM-dd 23:59:59"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateShow = false">取 消</el-button>
        <el-button type="primary" @click="updateEndTime()">修 改</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="refundShow"
      width="50%"
      title="合作门店设置"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="退款原因" required>
          <el-input v-model="refundRemark" type="textarea"></el-input>
        </el-form-item>
        取消所有的门店的合作，保证金退回到教练账户
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmRefund">确认退款</el-button>
      </span>
    </el-dialog>

    <shopCoopEdit @success="search" ref="edit"></shopCoopEdit>
  </div>
</template>

<script>
import shopCoopEdit from "./shopCoopEdit.vue";
import { coopType } from "./dict";
export default {
  components: {
    shopCoopEdit,
  },
  data() {
    return {
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
      updateShow: false,
      curItem: {},
      coopType,
      DataList: [],
      Option: [
        { name: "机构名称", value: "mechanism.mechanism_name" },
        { name: "合作类型", value: "type", type: "custom" },
        { name: "合作类目", value: "category" },
        { name: "营业额分成", value: "ratio" },
        { name: "状态", value: "status", type: "custom" },
        { name: "到期时间", value: "end_time", type: "custom" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      unPayDataList: [],
      unPayOption: [
        { name: "金额", value: "amount" },
        { name: "类型", value: "type", type: "custom" },
        { name: "状态", value: "status", type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      unPayTotal: 0,
      type: "",
      coach_id: "",
      show: false,
      refundShow: false,
      refundRemark: "",
    };
  },
  mounted() {
    this.coach_id = this.$route.query.id;
  },

  methods: {
    openRefund() {
      this.refundRemark = "";
      this.refundShow = true;
    },
    confirmRefund() {
      if (!this.refundRemark) {
        this.$message("请输入退款说明");
        return;
      }
      let url = "/user/coachUnionPartnership/coopRefund";
      let data = {
        handler_admin_id: this.adminInfo.id,
        handler_admin: this.adminInfo.name,
        coach_id: this.coach_id,
        remark: this.refundRemark,
      };
      this.refundShow = false;
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "成功!" });
        this.search();
      });
    },
    search() {
      this.getList(1);
      this.getUnPayList(1);
    },
    init() {
      if (this.coach_id && this.DataList.length == 0) {
        this.getList(1);
        this.getUnPayList(1);
      }
    },
    cancelPartner(row) {
      this.$confirm("确认取消保证金订单？").then((res) => {
        this.$post("/user/coachUnionPartnership/cancelPartner", {
          id: row.id,
        }).then((res) => {
          this.search();
        });
      });
    },
    updateStatus(row, status) {
      this.$post("/user/coachUnionPartnership/update", {
        id: row.id,
        status,
      }).then((res) => {
        this.getList(1);
      });
    },
    openTimeUpdate(row) {
      this.curItem = row;
      this.updateShow = true;
    },
    openSet(row) {
      this.$refs.edit.open(row);
    },
    add() {
      this.$refs.edit.open();
    },
    updateEndTime() {
      let data = {
        id: this.curItem.id,
        start_time: this.curItem.start_time,
        end_time: this.curItem.end_time,
      };

      this.$post("/user/coachUnionPartnership/update", data).then((res) => {
        this.updateShow = false;
        this.getList(1);
      });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/coachUnionPartnership/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          coach_id: this.coach_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    //获取列表
    getUnPayList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/coachUnpaidAmount/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          coach_id: this.coach_id,
        },
      }).then((res) => {
        this.unPayDataList = res.data.data.rows;
        this.unPayTotal = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.time_edit {
  color: rgb(78, 151, 235);
}
</style>